import { createContext, useContext } from 'react';

export const FormPreviewContext = createContext<boolean>(false);

/**
 * Distinguishes the form editor's preview from a real form. Deliberately
 * separate from {@link useIsInModal}: the preview is always inside a modal, but
 * not every modal form is a preview, and the two want different guidance
 * behaviour — a record modal still offers guidance in a popover, the preview
 * offers none at all (CUS-201).
 *
 * @returns true if the component is rendered inside the form editor's preview
 */
export const useIsInFormPreview = () => {
  const context = useContext(FormPreviewContext);

  return !!context;
};
